import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const StyledContentLoader = styled(ContentLoader)`
  width: 100%;
`;

const ProductDetailGallery = props => (
  <StyledContentLoader
    speed={2}
    viewBox="0 0 270 450"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="0" y="0" rx="4" ry="4" width="40" height="40" />
    <rect x="50" y="0" rx="4" ry="4" width="100%" height="450" />
  </StyledContentLoader>
);

export default ProductDetailGallery;
